import ChartHeader from './ChartHeader.container';

export default ChartHeader;
